import React, { ReactNodeArray, Fragment, useCallback, useContext, useState } from 'react'
import { ThemeContext } from 'styled-components'
import { Carousel, ScreenContext } from 'react-components'

import { PrimaryFAQTransport } from '@common/transports/deprecated-home-page-transport'
import PrimaryFAQCard from './primary-faq-card'
import CarouselDot from './carousel-dot'
import { CardContainerDesktop } from './primary-faq-card-styles'

interface Props {
    primaryFAQs: PrimaryFAQTransport[]
}

const _initialSlide = 0

// For the purpose of accessibility.
const _appendDots = (dots: ReactNodeArray) => <ul>{dots}</ul>

const PrimaryFAQs: React.FC<Props> = ({ primaryFAQs }) => {
    const [currentSlide, setCurrentSlide] = useState(_initialSlide)
    const theme = useContext(ThemeContext)
    const { isMobile, isTablet, isDesktop } = useContext(ScreenContext)

    const _customPaging = useCallback(
        index => (
            <CarouselDot
                fillColor={index === currentSlide ? theme.colors.tfwBlue : theme.colors.tfwBlack12}
                label={index + 1}
            />
        ),
        [theme, currentSlide],
    )

    const _beforeChange = useCallback(
        (_, nextIndex) => {
            setCurrentSlide(nextIndex)
        },
        [setCurrentSlide],
    )

    return (
        <Fragment>
            {isDesktop && (
                <CardContainerDesktop>
                    {primaryFAQs.map(faq => (
                        <PrimaryFAQCard key={faq.title} faq={faq} />
                    ))}
                </CardContainerDesktop>
            )}
            {!isDesktop && (
                <Carousel
                    slidesToShow={isTablet ? 2 : 1}
                    arrows={false}
                    infinite={false}
                    centerMode={isMobile}
                    centerPadding={isMobile ? '20px' : undefined}
                    dots
                    initialSlide={_initialSlide}
                    beforeChange={_beforeChange}
                    customPaging={_customPaging}
                    appendDots={_appendDots}
                >
                    {primaryFAQs.map(faq => (
                        <PrimaryFAQCard key={faq.title} faq={faq} />
                    ))}
                </Carousel>
            )}
        </Fragment>
    )
}

export default PrimaryFAQs
